import { surveyLocalization } from "../surveyStrings";

export var icelandicSurveyStrings = {
  pagePrevText: "Tilbaka",
  pageNextText: "Áfram",
  completeText: "Lokið",
  previewText: "Forskoða",
  editText: "Breyta",
  startSurveyText: "Byrjaðu",
  otherItemText: "Hinn (skýring)",
  noneItemText: "Enginn",
  selectAllItemText: "Velja allt",
  progressText: "Síða {0} of {1}",
  panelDynamicProgressText: "Taka upp {0} af {1}",
  questionsProgressText: "Svarað {0} / {1} spurningum",
  emptySurvey: "Það er enginn síða eða spurningar í þessari könnun.",
  completingSurvey: "Takk fyrir að fyllja út þessa könnun!",
  completingSurveyBefore:
    "Skrár okkar sýna að þú hefur þegar lokið þessari könnun.",
  loadingSurvey: "Könnunin er að hlaða...",
  optionsCaption: "Veldu...",
  value: "gildi",
  requiredError: "Vinsamlegast svarið spurningunni.",
  requiredErrorInPanel: "Vinsamlegast svaraðu að minnsta kosti einni spurningu.",
  requiredInAllRowsError: "Vinsamlegast svarið spurningum í öllum röðum.",
  numericError: "Þetta gildi verður að vera tala.",
  textMinLength: "Það ætti að vera minnst {0} tákn.",
  textMaxLength: "Það ætti að vera mest {0} tákn.",
  textMinMaxLength: "Það ætti að vera fleiri en {0} og færri en {1} tákn.",
  minRowCountError: "Vinsamlegast fyllið úr að minnsta kosti {0} raðir.",
  minSelectError: "Vinsamlegast veljið að minnsta kosti {0} möguleika.",
  maxSelectError: "Vinsamlegast veljið ekki fleiri en {0} möguleika.",
  numericMinMax:
    "'{0}' ætti að vera meira en eða jafnt og {1} minna en eða jafnt og {2}",
  numericMin: "{0}' ætti að vera meira en eða jafnt og {1}",
  numericMax: "'{0}' ætti að vera minna en eða jafnt og {1}",
  invalidEmail: "Vinsamlegast sláið inn gilt netfang.",
  invalidExpression: "Tjáningin: {0} ætti að skila 'satt'.",
  urlRequestError: "Beiðninn skilaði eftirfaranadi villu '{0}'. {1}",
  urlGetChoicesError: "Beiðninng skilaði engum gögnum eða slóðinn var röng",
  exceedMaxSize: "Skráinn skal ekki vera stærri en {0}.",
  otherRequiredError: "Vinamlegast fyllið út hitt gildið.",
  uploadingFile:
    "Skráinn þín var send. Vinsamlegast bíðið í nokkrar sekúndur og reynið aftur.",
  loadingFile: "Hleður ...",
  chooseFile: "Veldu skrár ...",
  noFileChosen: "Engin skrá valin",
  confirmDelete: "Viltu eyða skránni?",
  keyDuplicationError: "Þetta gildi ætti að vera einstakt.",
  addColumn: "Bæta við dálki",
  addRow: "Bæta við röð",
  removeRow: "Fjarlægja",
  addPanel: "Bæta við nýju",
  removePanel: "Fjarlægðu",
  choices_Item: "hlutur",
  matrix_column: "Dálkur",
  matrix_row: "Röð",

  savingData: "Niðurstöðurnar eru að spara á netþjóninum ... ",
  savingDataError: "Villa kom upp og við gátum ekki vistað niðurstöðurnar.",
  savingDataSuccess: "Árangurinn var vistaður með góðum árangri!",
  saveAgainButton: "Reyndu aftur",
  timerMin: "mín",
  timerSec: "sek",
  timerSpentAll: "Þú hefur eytt {0} á þessari síðu og {1} samtals.",
  timerSpentPage: "Þú hefur eytt {0} á þessari síðu.",
  timerSpentSurvey: "Þú hefur eytt {0} samtals.",
  timerLimitAll:
    "Þú hefur eytt {0} af {1} á þessari síðu og {2} af {3} samtals.",
  timerLimitPage: "Þú hefur eytt {0} af {1} á þessari síðu.",
  timerLimitSurvey: "Þú hefur eytt {0} af {1} samtals.",
  cleanCaption: "Hreint",
  clearCaption: "Hreinsa",
  chooseFileCaption: "Veldu skrá",
  removeFileCaption: "Fjarlægðu þessa skrá",
  booleanCheckedLabel: "Já",
  booleanUncheckedLabel: "Nei",
  confirmRemoveFile: "Ertu viss um að þú viljir fjarlægja þessa skrá: {0}?",
  confirmRemoveAllFiles: "Ertu viss um að þú viljir fjarlægja allar skrár?",
  questionTitlePatternText: "Spurningartitill",
};

surveyLocalization.locales["is"] = icelandicSurveyStrings;
surveyLocalization.localeNames["is"] = "íslenska";



// WEBPACK FOOTER //
// ./src/localization/icelandic.ts